import { render, staticRenderFns } from "./shopNav.vue?vue&type=template&id=0a34473e&scoped=true&"
import script from "./shopNav.vue?vue&type=script&lang=js&"
export * from "./shopNav.vue?vue&type=script&lang=js&"
import style0 from "./shopNav.vue?vue&type=style&index=0&id=0a34473e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34473e",
  null
  
)

export default component.exports